<dashboard-dialog-frame class="volunteer-topics-form-dialog" [header]="headerTitle()" [dialogRef]="dialogRef">
	<div class="px-2 py-4 d-flex flex-column justify-content-between h-100">
		<div class="d-flex flex-column gap-3">
			<common-select-field [field]="topic()"></common-select-field>
			<common-select-field [field]="status()"></common-select-field>
			<common-text-field [field]="note()"></common-text-field>
		</div>

		<common-button-row [center]="true">
			<button #topicSaveBtn class="btn btn-standard">
				{{dialogContext.data?.mode === dialogMode.ADD ? 'Add Topic' : 'Save Changes'}}
			</button>
			<button class="btn btn-standard" (click)="closeDialog()">Close</button>
		</common-button-row>
	</div>
</dashboard-dialog-frame>